export const MAX_ROADMAP_CLIENTS = 5;

export type RoadmapClient = {
  id: string;
  attributes: any;
};

export type RoadmapClientLink = {
  clientId: string | null;
  name: string;
  link: string;
};

export const formatRoadmapClients = (clientInformations?: any[]): RoadmapClient[] =>
  (clientInformations || []).map((client) => ({ id: String(client.id), attributes: client }));

export const clientIdsWithSlot = (
  clients: RoadmapClient[],
  slot: number,
  savedClientId: string | number
): number[] => {
  const ids = clients.map((client) => Number(client.id));
  ids[slot] = Number(savedClientId);

  return ids.filter((id, index) => ids.indexOf(id) === index);
};

export const clientIdsWithoutSlot = (clients: RoadmapClient[], slot: number): number[] =>
  clients.filter((_client, index) => index !== slot).map((client) => Number(client.id));

export const buildRoadmapClientLink = (
  origin: string,
  accountId: string | number | null,
  clientId: string | number | null,
  roadmapId: string | number | null
): string => {
  let roadmapLink = `${origin}/roadmapPackageSelectionByClient?`;
  let params = "";
  if (accountId) {
    params += `?accountId=${accountId}`;
  }
  if (clientId) {
    params += `&clientId=${clientId}`;
  }
  if (roadmapId) {
    params += `&roadmapId=${roadmapId}`;
  }
  if (params) {
    roadmapLink += `roadmapId=${btoa(params)}`;
  }
  return roadmapLink;
};

export const buildRoadmapClientLinks = (
  origin: string,
  accountId: string | number | null,
  roadmapId: string | number | null,
  clients: RoadmapClient[]
): RoadmapClientLink[] =>
  clients.map((client) => ({
    clientId: client.id,
    name: `${client.attributes?.first_name || ""} ${client.attributes?.last_name || ""}`.trim(),
    link: buildRoadmapClientLink(origin, accountId, client.id, roadmapId),
  }));
